const lang = {
    locale: "en-US",
    cancel: 'Cancel',
    close: 'Close',
    ok: 'OK',
    country: {
        china: 'China',
        hongKong: 'HongKong',
        macau: 'Macau',
        taiwan: 'Taiwan',
        singapore: 'Singapore',
        malaysia: 'Malaysia',
        indonesia: 'Indonesia',
        thailand: 'Thailand',
        philippines: 'Philippines',
        vietnam: 'Vietnam',
        myanmar: 'Myanmar'
    },
    friendlyTime: {
        just: 'Just',
        yesterday: 'Yesterday',
        oneMinuteAgo: '1 minute ago',
        minutesAgo: 'minutes ago',
        oneHourAgo: '1 hour ago',
        hoursAgo: 'hours ago',
        daysAgo: 'days ago',
        weeksAgo: 'weeks ago',
    },
    enterTheContent: 'Please enter the content',
    multilingual: 'Multilingual',
    loading: 'Loading…',
    select: 'Please select',
    page: {
        loadMore: 'Load More',
        loading: 'Loading',
        noMore: 'There is no more data'
    },
    empty: {
        data: 'No data yet',
        search: 'Search no results',
        develop: 'Under construction, working hard to maintain',
        network: 'No network yet',
        server: 'The server is wrong',
        404: '404',
        approve: 'Patience, review, please be patient'
    },
    pagination: {
        total: 'Total',
        item: 'item',
        items: 'items',
        page: '/page',
        goto: 'Goto',
        pageItem: ''
    },
    selectMember: {
        all: 'All',
        title: 'Select Member',
        titleRange: 'Select Range',
        selected:'Selected',
        search: 'Search',
        clear:'Clear',
        cancel:'Cancel',
        ok:'OK',
        dept:'Department',
        recentMember: 'Recent',
        deptMember:'Department member',
        group:'Group',
        groupMember:'Group member',
        team: 'Team',
        teamMember: 'Team member',
        member:'Member',
        role: 'Role',
        roleMember: 'Role member',
        external: 'External member',
        other: 'other',
        includingSubordinate: 'Including subordinate',
        cancelSubordinate: 'Cancel subordinate',
        includingSubordinateOrg: 'Including subordinate orgs',
        cancelSubordinateOrg: 'Cancel subordinate orgs',
        publicTeam: 'Public team',
        privateTeam: 'Personal team',
        maximum: 'The maximum limit has been exceeded',
        enterKeywordToSearch: 'Enter keyword to search',
        external: 'External',
        externalMember: 'External Member',
    },
    datepicker: {
        selectDate: "Select date",
        selectTime: "Select time",
        startTime: "Start Time",
        endTime: "End Time",
        clear: "Clear",
        ok: "OK",
        datePanelLabel: "[mmmm] [yyyy]",
        month: "Month",
        month1: "January",
        month2: "February",
        month3: "March",
        month4: "April",
        month5: "May",
        month6: "June",
        month7: "July",
        month8: "August",
        month9: "September",
        month10: "October",
        month11: "November",
        month12: "December",
        year: "Year",
        weekStartDay: "0",
        weeks: {
            sun: "Sun",
            mon: "Mon",
            tue: "Tue",
            wed: "Wed",
            thu: "Thu",
            fri: "Fri",
            sat: "Sat"
        },
        months: {
            m1: "Jan",
            m2: "Feb",
            m3: "Mar",
            m4: "Apr",
            m5: "May",
            m6: "Jun",
            m7: "Jul",
            m8: "Aug",
            m9: "Sep",
            m10: "Oct",
            m11: "Nov",
            m12: "Dec"
        }
    },
    table: {
        noDataText: "No Data",
        noFilteredDataText: "No filter data",
        confirmFilter: "Confirm",
        resetFilter: "Reset",
        clearFilter: "All"
    },
    upload: {
        file: 'Files',
        addFile: 'Add file',
        download: 'Download',
        upload: 'Upload',
        secretLevel: 'Secret level',
        dragFilesHereToUpload: 'Drag file here to upload',
        batchDownload: 'Batch download',
        preview: 'Preview',
        singleMaxSize: 's1%M max for a single file',
        allowDownload: 'Allow Download',
        fileUploading: 'Uploading ',
        public: 'PUBLIC',
        internal: 'INTERNAL',
        secret: 'SECRET',
        confidential: 'CONFIDENTIAL',
        pleaseSelectFileSecretLevel: 'Please select file secret level',
        fileUploadFailed: 'Upload failed',
        fileExceedsSizeLimit: 'The attachment exceeds the single attachment size limit',
        emptyFileIsNotAllowedToUpload: 'Empty files are not allowed to upload',
        upToCountFilesCanBeUploaded: 'Up to s1% files can be uploaded',
        pleaseSelectFile: 'Please select the files to download',
        noFiles: 'No files yet',
        delete: 'Delete',
        deleteSucceeded: 'Delete succeeded.',
        deleteFailed: 'Delete failed.',
        noAuthorization: 'Unauthorized operation'
    }
}

export default lang
